const searchMethodLabels = {
  addresses: 'Radius Around an Address',
  locations: 'Search an Area',
};

const locationPlaceTypes = new Set([
  'administrative_area_level_1',
  'administrative_area_level_2',
  'country',
  'locality',
  'postal_code',
]);

export const getFindNewContactsConfig = (orderDetails, overview) => {
  const contactImportLog = overview?.contactImportLog || orderDetails?.contactImportLogs?.[0] || {};
  const meta = contactImportLog.meta || orderDetails?.meta || {};
  const request = meta.request || orderDetails?.meta?.request || {};

  return request.config || meta.config || {};
};

export const getFindNewContactsSearchMethod = (orderDetails, overview) => {
  const config = getFindNewContactsConfig(orderDetails, overview);
  if (Object.values(searchMethodLabels).includes(config.searchMethod)) return config.searchMethod;
  if (searchMethodLabels[config.findNewMode]) return searchMethodLabels[config.findNewMode];

  const addressConfigs = Array.isArray(config.addressConfigs) ? config.addressConfigs : [];
  const hasLocationFilter =
    Boolean(config.locationFilter) ||
    addressConfigs.some((addressConfig) => Boolean(addressConfig?.locationFilter));
  const hasLocationPlaceType = [config, ...addressConfigs].some((addressConfig) =>
    (Array.isArray(addressConfig?.placeTypes) ? addressConfig.placeTypes : []).some((placeType) =>
      locationPlaceTypes.has(placeType)
    )
  );
  const hasDrawnArea =
    ['custom', 'draw-radius'].includes(config.areaMode) ||
    (Array.isArray(config.customShapes) && config.customShapes.length > 0) ||
    (Array.isArray(config.drawRadiusAreas) && config.drawRadiusAreas.length > 0);

  return hasDrawnArea || hasLocationFilter || hasLocationPlaceType
    ? searchMethodLabels.locations
    : searchMethodLabels.addresses;
};
